/**
 * FAF: lock Easy Appointment Booking (Servicify) to Michael Holladay
 * when the shopper arrives from cabinetry scheduling links.
 *
 * Activate via:
 *   /products/appointment?faf_cabinetry=1
 *   /products/appointment?employeeId=69843
 *   /products/appointment?faf_staff=michael-holladay
 *
 * Staff id is stored in sessionStorage so multi-step booking keeps the lock.
 */
(function () {
  var MICHAEL_ID = 69843;
  var MICHAEL_IDS = { '69843': true, '113180': true };
  var MICHAEL_SLUG = 'michael-holladay';
  var STORAGE_KEY = 'faf_cabinetry_staff_id';

  function onAppointmentPage() {
    try {
      return /\/products\/appointment\/?$/i.test(window.location.pathname || '');
    } catch (e) {
      return false;
    }
  }

  function readParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (e) {
      return null;
    }
  }

  function resolveStaffId() {
    var params = readParams();
    if (params) {
      var emp = params.get('employeeId') || params.get('employee_id') || params.get('staffId');
      if (emp && String(emp) === String(MICHAEL_ID)) {
        return MICHAEL_ID;
      }
      var staff = (params.get('faf_staff') || params.get('staff') || '').toLowerCase();
      if (staff === MICHAEL_SLUG || staff === 'michael' || staff.indexOf('holladay') !== -1) {
        return MICHAEL_ID;
      }
      if (params.get('faf_cabinetry') === '1' || params.get('faf_cabinetry') === 'true') {
        return MICHAEL_ID;
      }
    }
    return null;
  }

  var lockedId = resolveStaffId();
  if (!lockedId) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, String(lockedId));
  } catch (e3) {}

  if (!onAppointmentPage()) return;

  function isLockedEmployee(e) {
    if (!e) return false;
    var id = String(e.id || '');
    if (id === String(lockedId) || MICHAEL_IDS[id]) return true;
    var name = String(e.firstName || '') + ' ' + String(e.lastName || '');
    return /holladay/i.test(name);
  }

  function filterPayload(data) {
    if (!data || typeof data !== 'object') return data;
    try {
      if (Array.isArray(data.employees)) {
        data.employees = data.employees.filter(isLockedEmployee);
      }
      if (Array.isArray(data.employeePool)) {
        data.employeePool = data.employeePool.filter(isLockedEmployee);
      }
      // Prefer assigned scheduling, not random pool
      if ('randomlyAssignEmployee' in data) data.randomlyAssignEmployee = false;
    } catch (e4) {}
    return data;
  }

  function maybeFilterJsonText(text) {
    try {
      var data = JSON.parse(text);
      return JSON.stringify(filterPayload(data));
    } catch (e5) {
      return text;
    }
  }

  // Patch fetch (if used)
  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (!url || url.indexOf('servicify-appointments') === -1) return res;
        if (url.indexOf('/events') === -1 && url.indexOf('/allEvents') === -1) return res;
        return res
          .clone()
          .text()
          .then(function (text) {
            var filtered = maybeFilterJsonText(text);
            return new Response(filtered, {
              status: res.status,
              statusText: res.statusText,
              headers: res.headers
            });
          })
          .catch(function () {
            return res;
          });
      });
    };
  }

  // Patch XHR (Servicify uses XHR/axios-style GET)
  if (typeof XMLHttpRequest !== 'undefined') {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fafUrl = url || '';
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__fafUrl || '';
      if (
        url &&
        url.indexOf('servicify-appointments') !== -1 &&
        (url.indexOf('/events') !== -1 || url.indexOf('/allEvents') !== -1)
      ) {
        xhr.addEventListener('readystatechange', function () {
          if (xhr.readyState !== 4) return;
          try {
            var raw = xhr.responseText;
            if (!raw) return;
            var filtered = maybeFilterJsonText(raw);
            if (filtered === raw) return;
            try {
              Object.defineProperty(xhr, 'responseText', { configurable: true, get: function () { return filtered; } });
            } catch (e6) {}
            try {
              Object.defineProperty(xhr, 'response', { configurable: true, get: function () { return filtered; } });
            } catch (e7) {}
          } catch (e8) {}
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  // Hide non-Michael staff options if the UI still lists them
  function scrubStaffUi() {
    var roots = document.querySelectorAll(
      '.servicify-app, [class*="servicify"], [id*="servicify"], [class*="easy-appointment"], [data-servicify]'
    );
    var scope = roots.length ? roots : [document.body];
    for (var r = 0; r < scope.length; r++) {
      var root = scope[r];
      if (!root || !root.querySelectorAll) continue;
      var nodes = root.querySelectorAll('button, label, li, div, span, option');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text || text.length > 80) continue;
        var isMichael = /michael\s*holladay/i.test(text) || /holladay/i.test(text);
        var looksLikeStaff =
          /savannah|rogers|lexi|wertheim/i.test(text) ||
          (/^[A-Z][a-z]+\s+[A-Z][a-z]+$/.test(text) && !/select|continue|book|next|back|time|date/i.test(text));
        if (looksLikeStaff && !isMichael) {
          var row = el.closest('button, label, li, [role="option"], [role="radio"], .employee, [class*="employee"], [class*="staff"]') || el;
          row.style.setProperty('display', 'none', 'important');
        }
      }
    }
  }

  function bootUiScrub() {
    scrubStaffUi();
    try {
      var obs = new MutationObserver(function () {
        scrubStaffUi();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        try {
          obs.disconnect();
        } catch (e9) {}
      }, 45000);
    } catch (e10) {}
    [400, 1000, 2000, 4000, 8000, 12000].forEach(function (ms) {
      setTimeout(scrubStaffUi, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootUiScrub);
  } else {
    bootUiScrub();
  }
})();
